import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ClaimTypes} from "../../../model/claim-type.model";
import {TransactionInfoService} from "../../../services/transaction-info.service";

@Component({
    selector: 'app-damage-personal-item',
    templateUrl: './damage-personal-item.component.html',
    styleUrls: ['./damage-personal-item.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DamagePersonalItemComponent implements OnInit {

    constructor(private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_BAG_DMG]);
    }

  ngOnInit() {
  }

}
